// Warehouse billing calls the per-package fee "Handling" (stored as feeType
// 'customs' / customsTotal). Mirrors the admin FEE_TYPE_LABELS and legacy-api
// common/utils/warehouse-invoice-totals.js#displayLineItemDescription.
const FEE_TYPE_LABELS: Record<string, string> = {
  warehousing: 'Warehousing',
  inspection: 'Inspection',
  description: 'Description',
  shipping_bag: 'Shipping Bag',
  missing_code: 'Missing Code',
  customs: 'Handling',
  freight: 'Freight',
  sea_freight: 'Sea Freight',
  transportation: 'Transportation',
  peak_surcharge: 'Peak Surcharge',
  other: 'Other',
};

interface LineItemLike {
  feeType?: string | null;
  description?: string | null;
}

export function feeTypeLabel(feeType: string | null | undefined): string {
  if (!feeType) return '';
  return FEE_TYPE_LABELS[feeType] || feeType;
}

// Rows generated before the rename are stored as "Customs charge for package …".
export function displayLineItemDescription(li: LineItemLike | null | undefined): string {
  const description = li?.description || '';
  if (li?.feeType === 'customs') {
    return description.replace(/^Customs charge/, 'Handling charge');
  }
  return description;
}
